import { Flex, Sidebar, SidebarMenu, SidebarMenuItem } from '@bitrise/bitkit';
import React, { FunctionComponent, useContext } from 'react';
import { Route, Link as RouterLink, useParams } from 'react-router-dom';

import dataAtIds from '../../dataAtIds.json';
import useFeatures from '../Features/useFeatures';
import { URLStateContext } from '../URLState/URLState';
import AppSidebarPanel from './AppSidebarPanel';

interface Props {
  isAppFullLayout: boolean;
  onHide: () => void;
}

const AppSidebar: FunctionComponent<Props> = (props) => {
  const { isAppFullLayout, onHide } = props;
  const { appId } = useParams<{ appId: string }>();
  const { to } = useContext(URLStateContext);
  const { hasFeature } = useFeatures();

  return (
    <Sidebar data-trace-at-id={dataAtIds.Sidebar} direction="vertical">
      <Flex grow>
        {hasFeature('enable-overview') && (
          <Route path="/:appId/overview">
            {({ match }) => (
              <SidebarMenu active={!!match}>
                <SidebarMenuItem
                  Component={RouterLink}
                  data-trace-at-id={dataAtIds.SidebarOverview}
                  icon="Request"
                  onClick={onHide}
                  to={to(`/${appId}/overview`)}
                >
                  Overview
                </SidebarMenuItem>
              </SidebarMenu>
            )}
          </Route>
        )}

        <Route path="/:appId/appPerformance">
          {({ match }) => (
            <SidebarMenu active={!!match}>
              <SidebarMenuItem
                Component={RouterLink}
                data-trace-at-id={dataAtIds.SidebarPerformance}
                icon="Trigger"
                onClick={onHide}
                to={to(`/${appId}/appPerformance`)}
              >
                App Performance
              </SidebarMenuItem>
            </SidebarMenu>
          )}
        </Route>

        {hasFeature('enable-builds-performance') && (
          <Route path="/:appId/buildPerformance">
            {({ match }) => (
              <SidebarMenu active={!!match}>
                <SidebarMenuItem
                  Component={RouterLink}
                  data-trace-at-id={dataAtIds.SidebarBuilds}
                  icon="Build"
                  onClick={onHide}
                  to={to(`/${appId}/buildPerformance`)}
                >
                  Build Performance
                </SidebarMenuItem>
              </SidebarMenu>
            )}
          </Route>
        )}

        <Route path="/:appId/crashes">
          {({ match }) => (
            <SidebarMenu active={!!match}>
              <SidebarMenuItem
                Component={RouterLink}
                data-trace-at-id={dataAtIds.SidebarCrashes}
                icon="TestFailed"
                onClick={onHide}
                to={to(`/${appId}/crashes`)}
              >
                Crashes
              </SidebarMenuItem>
            </SidebarMenu>
          )}
        </Route>

        {!isAppFullLayout && (
          <>
            <SidebarMenu active={false}>
              <SidebarMenuItem
                Component={RouterLink}
                data-trace-at-id={dataAtIds.SidebarGettingStarted}
                icon="Info"
                onClick={onHide}
                to={to(`/${appId}/o/getting-started`)}
              >
                Getting Started
              </SidebarMenuItem>
            </SidebarMenu>

            <Route path="/:appId/settings">
              {({ match }) => (
                <SidebarMenu active={!!match}>
                  <SidebarMenuItem
                    Component={RouterLink}
                    data-trace-at-id={dataAtIds.SidebarSettings}
                    icon="Settings"
                    onClick={onHide}
                    to={to(`/${appId}/settings`)}
                  >
                    Settings
                  </SidebarMenuItem>
                </SidebarMenu>
              )}
            </Route>
          </>
        )}
      </Flex>

      <Flex>
        <AppSidebarPanel />
      </Flex>
    </Sidebar>
  );
};

export default AppSidebar;
